// New session ids for anonymous sessions. Whoever knows a session id can
// change that session's stimulation, so the id must not be guessable:
// Math.random() is not a cryptographic generator, crypto.getRandomValues is.
// 12 random bytes = 96 bits, base64url-encoded like secrets.token_urlsafe()
// on the backend (12 bytes encode to exactly 16 characters, no padding).
export function newSessionId() {
  const bytes = new Uint8Array(12);
  window.crypto.getRandomValues(bytes);
  return btoa(String.fromCharCode.apply(null, bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}
